import request from '@/api/request'

const url = '/home'

// 获取统计数据
export const getCountData = (params) => {
    return request({
        url: url + '/count',
        params
    })
}